import React from "react";
import { useSelector } from "react-redux";
import * as Icon from "react-feather";

// Sidebar Data function
export const SidebarData = (translation) => [
  {
    key: "home",
    label: translation.home || "Home",
    submenuOpen: true,
    showSubRoute: true,
    icon: <Icon.Home />,
    submenuHdr: translation.home || "Home",
    link: "/",
    submenuItems: [{}],
  },
  {
    key: "reports",
    label: translation.reports || "Reports",
    submenuOpen: true,
    showSubRoute: false,
    icon: <Icon.BarChart />,
    submenuHdr: translation.reports || "Reports",
    submenuItems: [
      {
        title: translation.layouts || "Layouts",
        subData: [
          {
            key: "operations",
            label: translation.operations || "Operation",
            link: "/operations",
            icon: <Icon.Codepen />,
            showSubRoute: false,
            submenu: false,
          },
          {
            key: "marketing",
            label: translation.marketing || "Marketing",
            link: "/marketing",
            icon: <Icon.Speaker />,
            showSubRoute: false,
            submenu: false,
          },
          {
            key: "staffing",
            label: translation.staffing || "Staffing",
            link: "/staffing",
            icon: <Icon.Tag />,
            showSubRoute: false,
            submenu: false,
          },
          {
            key: "analytics",
            label: translation.analytics || "Analytics",
            link: "/analytics",
            icon: <Icon.Layers />,
            showSubRoute: false,
            submenu: false,
          },
        ],
      },
    ],
  },
  {
    key: "settings",
    label: translation.settings || "Settings",
    submenuOpen: true,
    showSubRoute: false,
    icon: <Icon.Settings />,
    submenuHdr: translation.settings || "Settings",
    submenuItems: [
      {
        title: translation.settings || "Settings",
        subData: [
          {
            key: "admin-dashboard",
            label: translation.manage_layouts || "Manage Layouts",
            link: "/admin-dashboard",
            icon: <Icon.Grid />,
            showSubRoute: false,
            submenu: false,
          },
        ],
      },
      {
        title: translation.store_pages || "Store Pages",
        subData: [
          {
            key: "stores",
            label: translation.stores || "Stores",
            link: "/store-list",
            icon: <Icon.Home />,
            showSubRoute: false,
            submenu: false,
          },
          {
            key: "users",
            label: translation.users || "Users",
            link: "/users",
            icon: <Icon.Users />,
            showSubRoute: false,
          },
          {
            key: "roles-permissions",
            label: translation.roles_permissions || "Roles & Permissions",
            link: "/roles-permissions",
            icon: <Icon.UserCheck />,
            showSubRoute: false,
          },
        ],
      },
    ],
  },
  {
    key: "tool",
    label: translation.tools || "Tools",
    submenuOpen: true,
    showSubRoute: false,
    icon: <Icon.Tool />,
    submenuHdr: translation.tools || "Tools",
    submenuItems: [
      {
        title: translation.tools || "Tools",
        subData: [
          {
            key: "import-data",
            label: translation.import || "Import",
            link: "/import-data",
            icon: <Icon.Users />,
            showSubRoute: false,
          },
          {
            key: "export-data",
            label: translation.export || "Export",
            link: "/export-data",
            icon: <Icon.Users />,
            showSubRoute: false,
          },
        ],
      },
    ],
  },
  {
    key: "account",
    label: translation.manage_account || "Manage Account",
    submenuOpen: true,
    showSubRoute: false,
    icon: <Icon.Users />,
    submenuHdr: translation.manage_account || "Manage Account",
    submenuItems: [
      {
        title: translation.manage_account || "Manage Account",
        subData: [
          {
            key: "profile",
            label: translation.profile || "Profile",
            link: "/profile",
            icon: <Icon.User />,
            showSubRoute: false,
          },
        ],
      },
    ],
  },
];


